import { useEffect, useState } from "react";
import {Card, CircularProgress, Grid} from "@mui/material";
import api from "../../helpers/api/Api";
import ApiUrls from "../../helpers/urls/ApiUrls";
import { showStatus } from "../../helpers/api/errors/ShowStatus";
import { getGraphObject } from "./functions/getGraphObject";
import MDBox from "components/MDs/MDBox";
import DashboardLayout from "../../components/LayoutContainers/DashboardLayout";
import Filter from "./components/filter";
import PieGraph from "./components/pieGraph";
import ImgGraph from "./components/imgGraph";
import StatisticTable from "./components/statisticTable";
import LoadingProgress from "../../components/LoadingProgress";
import store from "../../redux/store";
import {useSelector} from "react-redux";
import AppConfig from "../../helpers/constants/AppConfig";

function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [graphs, setGraphs] = useState([]);
  const [filterData, setFilterData] = useState({
    ip: "",
    item: "",
    period: ""
  });
  const siteListLoaded = useSelector(state => state.site_list_loaded);
  const user_id = JSON.parse(localStorage.getItem("user"))?.id;

  const getStorageConfig = () => {
    let graph_config = [];
    const storageConfig = localStorage.getItem("graphConfig");
    if (storageConfig) {
      graph_config = JSON.parse(storageConfig);
    }
    return graph_config;
  }

  useEffect(() => {
    if (siteListLoaded) {
      getGraphConfig();
    }
  }, [siteListLoaded]);

  const getGraphConfig = () => {
    const graph_config = getStorageConfig();

    if (localStorage.getItem("graphConfig")) {
      setConfigData(graph_config);
    } else {
      setLoading(true);

      const fd = new FormData();
      fd.append("uid", user_id);

      api.post(ApiUrls.dashboard.getGraphConfig, fd)
         .then((response) => {
           if (response.data.status === "success") {
             const resConfig = response.data.config;
             const config = resConfig ? resConfig : "[]";
             localStorage.setItem("graphConfig", config);
             setConfigData(JSON.parse(config));
           } else {
             showStatus("dashboard_config_error");
           }
           setLoading(false);
         })
         .catch((error) => {
           setLoading(false);
           showStatus("dashboard_config_error");
         });
    }
  };
  const setConfigData = (data) => {
    const tempGraph =  [];

    for (let i = 0; i < data.length; i++) {
      const data_i = data[i];
      const newObj = { "ip": data_i[0], "item": data_i[1], "period": data_i[2] };
      const obj = getGraphObject(newObj);
      tempGraph.push(obj);
    }

    setGraphs(tempGraph);
  }

  const setGraphConfig = (graph_config) => {
    const newConfig = JSON.stringify(graph_config);
    localStorage.setItem("graphConfig", newConfig);

    const fd = new FormData();
    fd.append("uid", user_id);
    fd.append("config", newConfig);

    api.post(ApiUrls.dashboard.setGraphConfig, fd)
       .then((response) => {})
       .catch((error) => {});
  };
  const pushGraphConfig = (newGraph) => {
    const graph_config = getStorageConfig();

    const newObj = [];
    Object.entries(newGraph).forEach(([key, value], i) => {
      newObj[i] = value;
    });
    graph_config.push(newObj);

    setGraphConfig(graph_config);
  };

  const handleGraphChange = (op, i, value) => {
    const tempGraph =  [...graphs];

    switch (op) {
      case "add":
        const obj = getGraphObject(value);
        tempGraph.push(obj);
        pushGraphConfig(value);
        break;
      case "remove":
        tempGraph.splice(i, 1);
        const graph_config = getStorageConfig();
        graph_config.splice(i, 1);
        setGraphConfig(graph_config);
    }

    setGraphs(tempGraph);
  };

  return (
    <DashboardLayout>

      <MDBox py={1}>
        <Grid container spacing={3} justifyContent="center">

          <Grid item xs={12}>
            <Card sx={{ height: "100%", py: 4, px: 2 }}>
              <Filter
                 filterData={filterData}
                 setFilterData={setFilterData}
                 addNewGraph={handleGraphChange}
              />
            </Card>
          </Grid>

          {!loading
             ? (
                <>
                  {graphs.map((graph, index) => {
                    switch (graph.type) {
                      case "statistic":
                        return (
                           <StatisticTable
                              graphData={graph}
                              key={graph.id}
                              index={index}
                              handleGraphChange={handleGraphChange}
                           />
                        )
                      case "chart":
                        return (
                           <PieGraph
                              graphData={graph}
                              key={graph.id}
                              index={index}
                              handleGraphChange={handleGraphChange}
                           />
                        )
                      case "img":
                        return (
                           <ImgGraph
                              graphData={graph}
                              key={graph.id}
                              index={index}
                              handleGraphChange={handleGraphChange}
                           />
                        )
                    }
                  })}
                </>
             )
            : (
               <div className="d-flex justify-content-center w-100 my-5">
                 <CircularProgress color={AppConfig.color} />
               </div>
             )
          }
        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}

export default Dashboard;
